import type { Locale } from '../i18n';

const dateTimeFormatters = new Map<Locale, Intl.DateTimeFormat>();

export const formatDateTime = (value: string | Date, locale: Locale): string => {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  let formatter = dateTimeFormatters.get(locale);
  if (!formatter) {
    formatter = new Intl.DateTimeFormat(locale, {
      dateStyle: 'short',
      timeStyle: 'short',
    });
    dateTimeFormatters.set(locale, formatter);
  }
  return formatter.format(date);
};
